import React, {Component} from 'react'
import {getUploadHistory} from '../../../actions/data-import';
import UploadHistoryPanel from "./upload-history-panel";

class UploadHistory extends Component {

    render() {
        return (
            <div className="fluid">
                {this.props.data.map((value, key) =>
                    <UploadHistoryPanel  key={key} data={value} />
                )}
            </div>
        );
    }
}

export default UploadHistory;


// WEBPACK FOOTER //
// ./src/components/admin/data-import/upload-history.jsx